var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-layout-wrapper", on: { click: _vm.operate } },
    [
      _c("guide"),
      _vm._v(" "),
      _c("sidebar", {
        staticClass: "sidebar",
        attrs: { go: _vm.go, menuList: _vm.menuList }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "page-content" }, [
        _c(
          "div",
          { staticClass: "page-scroll-wrapper" },
          [
            _c("second-menu", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.name.indexOf("setting") === -1,
                  expression: "$route.name.indexOf('setting') === -1"
                }
              ],
              staticClass: "second-menu",
              class: { assets: _vm.$route.name.indexOf("assets") === 0 },
              attrs: { go: _vm.go, tabList: _vm.secondMenuList }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "page-wrapper" }, [_vm._t("default")], 2)
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }